import type { ReactNode } from 'react';
import { Button } from '@/shared/ui/button';
import { describeAgreementFailure } from '@/modules/agreements/shared';

/**
 * The final commit.
 *
 * This is the only control that records an execution. It is disabled until the signature
 * image exists, the signer's name is given, and — when the requirement demands it — a fresh
 * identity check has succeeded.
 */
export function SignCommitSection(props: {
  error: Error | null;
  busy: boolean;
  canSign: boolean;
  onSign: () => void;
  onBack: () => void;
}): ReactNode {
  return (
    <div className="space-y-4">
      {props.error ? (
        <p className="text-sm text-critical">{describeAgreementFailure(props.error)}</p>
      ) : null}
      <p className="text-sm text-content-muted">
        Signing records your execution against the content hash shown above. It cannot be undone.
      </p>
      <div className="flex gap-2">
        <Button loading={props.busy} disabled={!props.canSign} onClick={props.onSign}>
          Sign agreement
        </Button>
        <Button variant="secondary" onClick={props.onBack}>
          Back
        </Button>
      </div>
    </div>
  );
}
